import { Injectable } from '@angular/core';
import { io } from "socket.io-client";
import { Observable } from 'rxjs';
import { Router} from '@angular/router';
import { Events } from './events.service';
import { PtyNotificationService } from './pty-notification.service';
import { environment } from 'src/environments/environment';
import {TranslationService} from "./translation.service";

@Injectable({
    providedIn: 'root'
})
export class PtySocketService {

    private socket: any = null;
    private socketUrl: string = '';
    private teb_seeker = false
    private teb_seeker_request = false
    private teb_seeker_profile = false

    constructor(
        private router: Router,
        private events: Events,
        private notif: PtyNotificationService,
        private translationService: TranslationService,
    ) {
        this.socketUrl = environment.SOCKET_END_POINT;

    }

    // I am resorting to this because I can't find a way to do this natively with Angular using Router or ActivatedRoute in a Service singleton
    getCurrentRouteParamInHackishWay(paramName: string) {
        const url = this.router.url;
        const params = url.split(';');
        const paramArray = params.map(chunk => chunk.split('='));
        const routePart = paramArray.shift();
        const paramMap = {};
        for (let row of paramArray) {
            paramMap[row[0]] = row[1];
        }

        if (paramMap.hasOwnProperty(paramName)) {
            return paramMap[paramName];
        }
        return null;
    }

    connect(user: any) {
        this.socket = io(this.socketUrl, {
            query: { user: JSON.stringify(user) },
            transports: [ 'websocket' ]
        });

        // Subscribe for messages
        this.getMessages().subscribe((data: any) => {
            this.notif.addToStat('notifications', 1);
            this.events.publish('UpdateNotification');

            /*
             * Adding the second condition so that the toast message will display if you get a message from contact B
             *   when you are in the middle of chatting with contact A.  But it will not display for every message
             *   from contact A when you are actively live chatting with contact A.
             */
            if (this.router.url.indexOf('seeker-request') >= 0
                && this.getCurrentRouteParamInHackishWay('conversation') === data.message_data.extra_data.conversation_uuid
            ) {
                this.events.publish('message:received', data);
            } else {
                if(this.router.url.indexOf('tab-seekers') >= 0) {
                    this.events.publish('seeker-added');
                }
                let message = '';
                if (data.message_data && data.message_data.extra_data && data.message_data.extra_data.seeker_name) {
                    message = data.message_data.extra_data.seeker_name;
                }

                const buttonsOverride = [
                    // Provide the OM an option to chat with the contact immediately
                    {
                        text: this.translationService.translate('Chat now!'),
                        role: 'info',       // does this need to be 'cancel' ?
                        handler: () => {
                            console.log('in the chat now handler!', ['/seeker-request', {
                                conversation: data.message_data.extra_data.conversation_uuid,
                                channel: data.message_data.extra_data.channel,
                                seeker_name: data.message_data.extra_data.seeker_name
                            }]);
                            this.router.navigate(['/seeker-request', {
                                conversation: data.message_data.extra_data.conversation_uuid,
                                channel: data.message_data.extra_data.channel,
                                seeker_name: data.message_data.extra_data.seeker_name
                            }]);
                        },
                    },
                    // Normal dismiss the toast message option
                    {
                        text: 'Ok',
                        role: 'cancel',
                        side: 'end',
                    }
                ];
                this.notif.showLocalNotification(message, this.translationService.translate('New Message Received'), 10000, buttonsOverride);
            }
        }, (err) => {
            console.log('Error in trying to receive messages in realtime via SocketIO: ', err);
        });

        this.getNotificationUpdates().subscribe((data: any) => {
            // Can put general notification receiving stuff here.
            // This event is emitted by the notification bus at POST /send-notification on the socket server
        });

        // Subscribe for group messages
        this.getGroupMessages().subscribe((data: any) => {
            if (this.router.url.indexOf('group-messages') >= 0) {
                this.events.publish('group:message:received', data);
            } else {
                this.notif.showLocalNotification(data.message_data, this.translationService.translate('New Message Received'));
            }
        }, (err: any) => {
            console.error(err);
        });

        // Subscribe for AdminOmChat messages
        this.getAdminOmConversationMessages().subscribe((data: any) => {
            // Skip over any messages from yourself that somehow end up here.
            if (data.sender_type === 'O') {
                return;
            }

            if (this.router.url.indexOf('admin-om-chat-messages') >= 0) {
                this.events.publish('adminOmConversation:message:receive', data);
            } else {
                const messageText = data.message_data ?? data.msg_body;
                const notificationTypePhrase = this.translationService.translate('New message from your CL');
                this.notif.showLocalNotification(messageText, notificationTypePhrase);
            }
            this.events.publish('AdminOmUnreadCountIncrement');
        }, (err: any) => {
            console.error(err);
        });
        this.events.subscribe('seeker-request:tabseeker', (datas: any) => {
            this.teb_seeker = datas.value

        });
        this.events.subscribe('seeker-request', (datas: any) => {
            this.teb_seeker_request = datas.value

        });
        this.events.subscribe('seeker-profile', (datas: any) => {
            this.teb_seeker_profile = datas.value

        });
        this.getreassignmentcontact().subscribe((data: any) => {
            if (this.teb_seeker_request == true) {
                if (data.reassign == true) {
                    this.events.publish('reassign:contact:receive:inseekerrequest', data);
                }
            }
            if (this.teb_seeker == true) {
                // if (data.reassign == true) {
                // console.log("calling seeker tab event", data)
                this.events.publish('reassign:contact:receive', data);

            }
            if (this.teb_seeker_profile == true) {
                // if (data.reassign == true) {
                // console.log("calling seeker tab event", data)
                this.events.publish('reassign:contact:receive:profile', data);

            }

        })
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
        }
    }

    sendMessage(message: any) {
        if (this.socket) {
            this.socket.emit('message:send', message);
        }
    }

    getMessage() {
        return this.socket.fromEvent('message:receive');
    }

    getMessages() {
        return new Observable(observer => {
            this.socket.on('message:receive', (data: any) => {
                console.log('*** Received event from SocketIO: message:receive', data);
                observer.next(data);
            });
        });
    }

    getNotificationUpdates() {
        return new Observable(observer => {
            this.socket.on('notification:receive', (data: any) => {
                if (data.hasNotification) {
                    this.events.publish('UpdateNotification');
                }
                observer.next(data);
            });
        })
    }

    subscribeToGroup(groupUUID: any) {
        if (this.socket) {
            this.socket.emit('group:subscribe', { group_uuid: groupUUID });
        }
    }

    unsubscribeFromGroup(groupUUID: any) {
        if (this.socket) {
            this.socket.emit('group:unsubscribe', { group_uuid: groupUUID });
        }
    }

    sendGroupMessage(message: any) {
        if (this.socket) {
            this.socket.emit('group:message:send', message);
        }
    }

    getGroupMessages() {
        return new Observable(observer => {
            this.socket.on('group:message:receive', (data: any) => {
                if (data.hasNotification) {
                    this.events.publish('UpdateNotification');
                }
                observer.next(data);
            });
        })
    }

    subscribeToAdminOmConversation(UUID: any) {
        if (this.socket) {
            this.socket.emit('adminOmConversation:subscribe', { admin_conversation_uuid: UUID });
        }
    }

    unsubscribeFromAdminOmConversation(UUID: any) {
        if (this.socket) {
            this.socket.emit('adminOmConversation:unsubscribe', { admin_conversation_uuid: UUID });
        }
    }

    sendAdminOmConversationMessage(message: any) {
        if (this.socket) {
            this.socket.emit('adminOmConversation:message:send', message);
        }
    }

    getAdminOmConversationMessages() {
        return new Observable(observer => {
            this.socket.on('adminOmConversation:message:receive', (data: any) => {
                if (data.hasNotification) {
                    this.events.publish('UpdateNotification');
                }
                observer.next(data);
            });
        })
    }
    getreassignmentcontact() {
        return new Observable(observer => {
            this.socket.on('reassign:contact:receive', (data: any) => {
                if (data.hasNotification) {
                    this.events.publish('UpdateNotification');
                }
                observer.next(data);
            });
        })
    }

}
